import React from 'react';
import { SiteContent } from '../data/content';

interface FooterProps {
  content: SiteContent['footer'];
}

export const Footer: React.FC<FooterProps> = ({ content }) => {
  return (
    <footer className="editorial-footer" role="contentinfo">
      <div className="container footer-inner">
        <span className="footer-mark">{content.brandTag}</span>
        <a href="#hero" className="footer-back-link" aria-label="Back to top">
          {content.backToTop}
        </a>
      </div>
    </footer>
  );
};
